module.exports = __webpack_public_path__ + "img/4.90d2b903.svg";